<div class="d-flex m-5">
  <div class="col-2"></div>
  <p class="col-3 align-self-center font-24 color-gray-700"><ng-content></ng-content></p>
  <div class="col-5"><mat-icon svgIcon="{{ icon }}" class="w-100 h-100"></mat-icon></div>
  <div class="col-2"></div>
</div>
